<template>
  <div>
    <div class="modals">
      <b-modal
        class="modalNotif"
        :modal-class="true ? 'in':''"
        :hide-header-close="true"
        :title-tag="'h4'"
        cancel-title="Annuler"
        id="modalNotif"
        ref="modal"
        title="Mises à jour récentes"
        @ok="handleOk"
      >
        <div class="row">
          <div class="col-md-12">
            <div class=" well"
                 v-for="maj in getMajNixinut"
                 :key="maj.id">
              <h1>{{ maj.title }}</h1>
              <p v-html="maj.content"></p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1 id="vue">
          Intranet ABFT
          <!--        <small>Version 0.0.1</small>-->
        </h1>
      </section>


      <section class="content">

        <div class="row dashboardGraphs">

          <div class="col-md-6">
            <div class="info-box">
              <div class="overlay" v-if="loadingStats">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <span class="info-box-icon bg-aqua">
                       <BarChartjsDashboard
                         v-if="!loadingStats"
                         :chartdata="chartdataMembres"
                       ></BarChartjsDashboard>
            </span>
              <div class="info-box-content">
                <span class="info-box-text"> Membres qui seront licenciés au moins un jour en {{ getDate() }}</span>
                <div class="info-box-number">{{ chartdataMembres.misc.nombre }}
                  <span
                    :class="{'text-red':chartdataMembres.misc.percent<0,'text-green':chartdataMembres.misc.percent>=0, }">
                  ({{ chartdataMembres.misc.percent }}%  /  {{ chartdataMembres.misc.difference }} membres)
                </span>
                </div>
                <span class="info-box-text text-sm">{{ chartdataMembres.misc.licenciesDansClubsNonLicencies }} membres licenciés dans des clubs non-licenciés</span>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="info-box">
              <div class="overlay" v-if="loadingStats">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <span class="info-box-icon bg-aqua">
                       <BarChartjsDashboard
                         v-if="!loadingStats"
                         :chartdata="chartdataMembres"
                       ></BarChartjsDashboard>
            </span>
              <div class="info-box-content">
                <span class="info-box-text"> Membres en ordre de licence aujourd'hui le {{ getDate(true) }}</span>
                <div class="info-box-number">{{ chartdataMembres.misc.nombreToday }}
                  <span
                    :class="{'text-red':chartdataMembres.misc.percentToday<0,'text-green':chartdataMembres.misc.percentToday>=0, }">
                  ({{ chartdataMembres.misc.percentToday }}%  /  {{ chartdataMembres.misc.differenceToday }} membres)
                </span>
                </div>
                <span class="info-box-text text-sm">{{ chartdataMembres.misc.nombreTodayAnneePassee }} membres en ordre de licence l'année passée à la même date</span>
              </div>
            </div>
          </div>

          <!--          <div class="col-md-6">-->
          <!--            <div class="info-box">-->
          <!--              <div class="overlay" v-if="loadingStats">-->
          <!--                <i class="fa fa-refresh fa-spin"></i>-->
          <!--              </div>-->
          <!--              <span class="info-box-icon bg-aqua">-->
          <!--                       <BarChartjsDashboard-->
          <!--                         v-if="!loadingStats"-->
          <!--                         :chartdata="chartdataMembresRapport"-->
          <!--                       ></BarChartjsDashboard>-->
          <!--            </span>-->
          <!--              <div class="info-box-content">-->
          <!--                <span class="info-box-text">Membres qui seront licenciés au moins un jour Par rapport à l'année passée</span>-->
          <!--                <div class="info-box-number">{{ chartdataMembresRapport.misc.nombre }}-->
          <!--                  <span :class="{'text-red':chartdataMembresRapport.misc.percent<0,'text-green':chartdataMembresRapport.misc.percent>=0, }">-->
          <!--                  ({{ chartdataMembresRapport.misc.percent }}%  /  {{ chartdataMembresRapport.misc.difference }} membres)-->
          <!--                </span>-->
          <!--                </div>-->
          <!--                <span class="info-box-text text-sm">Au {{ getCurrentDate() }}: <strong>{{ chartdataMembresRapport.misc.nombre }}</strong> membres</span>-->
          <!--                <span class="info-box-text text-sm">Au {{ getCurrentDate(1) }}: <strong>{{ chartdataMembresRapport.misc.nombreAnPasse }}</strong> membres</span>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->

          <div class="col-md-6">
            <div class="info-box">
              <div class="overlay" v-if="loadingStats">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <span class="info-box-icon bg-aqua">
                       <BarChartjsDashboard
                         v-if="!loadingStats"
                         :chartdata="chartdataClubs"
                       ></BarChartjsDashboard>
            </span>
              <div class="info-box-content">
                <span class="info-box-text"> Clubs licenciés en {{ getDate() }}</span>
                <div class="info-box-number">{{ chartdataClubs.misc.nombre }}
                  <span
                    :class="{'text-red':chartdataClubs.misc.percent<0,'text-green':chartdataClubs.misc.percent>=0, }">
                  ({{ chartdataClubs.misc.percent }}%  /  {{ chartdataClubs.misc.difference }} clubs)
                </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">

            <div class="box box-primary">
              <div class="overlay"
                   v-if="false"
              >
                <i class="fa fa-refresh fa-spin"></i>
              </div>

              <div class="box-header with-border">
                <h3 class="box-title">Montant des récapitulatifs encodés et sommés</h3>
              </div>
              <div class="box-body">
                <LineChartjsDashboard
                  v-if="!loadingStats"
                  :chartdata="chartdataMontantsSomme"
                ></LineChartjsDashboard>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="box box-primary">
              <div class="overlay"
                   v-if="false"
              >
                <i class="fa fa-refresh fa-spin"></i>
              </div>

              <div class="box-header with-border">
                <h3 class="box-title">Montant des récapitulatifs encodés</h3>
              </div>
              <div class="box-body">
                <LineChartjsDashboard
                  v-if="!loadingStats"
                  :chartdata="chartdataMontants"
                ></LineChartjsDashboard>
              </div>
            </div>
          </div>
        </div>


      </section>
    </div>
  </div>
</template>

<script type="text/babel">
import BarChartjsDashboard from "./Outils/BarChartjsDashboard";
import LineChartjsDashboard from "./Outils/LineChartjsDashboard";
import {mapGetters, mapActions} from 'vuex'
import _ from 'lodash'

// var _ = require('underscore')
var moment = require('moment')
export default {
  data() {
    return {
      stats: null,
      colors: ['#ffb91d', '#f97817', '#6de304', '#ff0000', '#732bea', '#c913ad',
        '#e32d91', '#c830cc', '#4ea6dc', '#4775e7', '#8971e1', '#d54773',
        '#af5b5b', '#4800ff', '#276fbf', '#183059',
        '#ff7f00',
        '#ff4500',
        '#32cd32',
        '#ff1493',
        '#8a2be2',
        '#d02090',
        '#ff69b4',
        '#da70d6',
        '#87ceeb',
        '#6495ed',
        '#9370db',
        '#ff6eb4',
        '#cd5c5c',
        '#4169e1',
        '#1e90ff',
        '#1c1c1c',
      ],
      loadingStats: true,
      chartdataMontants: {
        labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        datasets: []
      },
      chartdataMontantsSomme: {
        labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        datasets: []
      },
      chartdataMembres: {
        misc: {
          nombre: 0,
          percent: 0,
          difference: 0,
          licenciesDansClubsNonLicencies: 0
        },
        labels: [],
        datasets: []
      },
      chartdataClubs: {
        misc: {
          nombre: 0,
          percent: 0,
          difference: 0,
        },
        labels: [],
        datasets: []
      },
      chartdataMembresRapport: {
        misc: {
          nombre: 0,
          nombreAnPasse: 0,
          percent: 0,
          difference: 0,
        },
        labels: [],
        datasets: []
      },
    }
  },
  methods: {
    ...mapActions({
      setMajNixinut: 'setMajNixinut',
    }),
    showModal() {
      if (this.getMajNixinut && this.getMajNixinut.length > 0)
        this.$bvModal.show('modalNotif')
      else
        this.$bvModal.hide('modalNotif')
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()

      let self = this;
      this.$http.post(this.getRoute('setMajNixinutRead'),
        {"ids_notifications": this.getMajNixinut.map((item) => item.id)}
      )
        .then(function (response) {
          $('#modalNotif').modal('hide')
          self.setMajNixinut(null)
        }, (response) => {
          self.$noty.error("Erreur serveur")
          $('#modalNotif').modal('hide')
        });

      // this.saveProfile()
      // this.$bvModal.hide('modalNotif')
    },

    getCurrentDate: function (yearsToSubstract = 0) {
      return moment().subtract(yearsToSubstract, 'years').format('DD/MM/YYYY')
    },
    getStatsClub: async function (force = false) {
      let self = this;
      this.loadingStats = true
      await this.$http.get(this.getRoute('Statistiques.getStatistiquesForDashboard')).then((response) => {
        this.stats = response.body
        // console.log(response)
        //C'EST MOCHE
        // setTimeout(() => {
        if (
          this.getChartDataForMembre() &&
          this.getChartDataForMembreRapportAnneePasse() &&
          this.getChartDataForClub() &&
          this.getChartDataForMontants() &&
          this.getChartDataForMontantsEnSomme()
        )
          this.loadingStats = false
        // }, 2000);
      }, (response) => {
      });
    },
    getChartDataForMembre: function () {
      this.chartdataMembres.datasets.push({
        label: 'Membres affiliés par année',
        backgroundColor: '#FFF',
        data: []
      })

      this.stats.membres.forEach((item, index, array) => {
        if (item.annee == moment().year()) {
          let percent = ((100 - (item.nombre * 100 / array[index - 1].nombre)) * -1).toFixed(2);
          let percentToday = ((100 - (item.nombreToday * 100 / array[index - 1].nombreToday)) * -1).toFixed(2);
          let difference = item.nombre - array[index - 1].nombre
          let differenceToday = item.nombreToday - array[index - 1].nombreToday
          this.chartdataMembres.misc = {
            nombre: item.nombre,
            nombreToday: item.nombreToday,
            nombreTodayAnneePassee: array[index - 1].nombreToday,
            percent: percent,
            percentToday: percentToday,
            difference: difference,
            differenceToday: differenceToday,
            licenciesDansClubsNonLicencies: Math.abs(item.ADEPS - item.nombreLicences),
          }
        }
        this.chartdataMembres.labels.push(item.annee);
        this.chartdataMembres.datasets[0].data.push(item.nombre)
      })
      return true
    },
    getChartDataForMembreRapportAnneePasse: function () {
      this.chartdataMembresRapport.datasets.push({
        label: 'Progression des inscriptions par rapport à l\'année passée',
        backgroundColor: '#FFF',
        data: []
      })

      this.stats.membres_rapport_annee_passee.forEach((item, index, array) => {
        if (item.annee == moment().year()) {
          let percent = ((100 - (item.nombre * 100 / array[index - 1].nombre)) * -1).toFixed(2);
          let difference = item.nombre - array[index - 1].nombre
          this.chartdataMembresRapport.misc = {
            nombre: item.nombre,
            nombreAnPasse: array[index - 1].nombre,
            percent: percent,
            difference: difference,
          }
        }
        this.chartdataMembresRapport.labels.push(moment(item.date).format('DD/MM/YYYY'));
        this.chartdataMembresRapport.datasets[0].data.push(item.nombre)
      })
      return true
    },
    getChartDataForClub: function () {
      this.chartdataClubs.datasets.push({
        label: 'Clubs affiliés par année',
        backgroundColor: '#FFF',
        data: []
      })

      this.stats.clubs.forEach((item, index, array) => {
        if (item.annee == moment().year()) {
          let percent = ((100 - (item.nombre * 100 / array[index - 1].nombre)) * -1).toFixed(2);
          let difference = item.nombre - array[index - 1].nombre
          this.chartdataClubs.misc = {
            nombre: item.nombre,
            percent: percent,
            difference: difference,
          }
        }
        this.chartdataClubs.labels.push(item.annee);
        this.chartdataClubs.datasets[0].data.push(item.nombre)
      })
      return true
    },
    getChartDataForMontants: function () {
      this.chartdataMontants.datasets = []
      //     label: 'Montants par année',
      //     backgroundColor: '#FFF000',
      //     data: []
      // })
      let monthCurrent = 1;
      let yearPrec = 0;
      let toPush = {}
      this.stats.montantsByYearByMonth.forEach((item, index, array) => {
        if (yearPrec != item.annee) {
          if (yearPrec != 0)
            this.chartdataMontants.datasets.push(toPush)
          yearPrec = item.annee
          monthCurrent = 1;
          let color = this.getColor()
          toPush = {
            label: item.annee,
            borderColor: this.hexToRGB(color, 1),
            backgroundColor: this.hexToRGB(color, 0.1),
            data: []
          }
        }
        if (monthCurrent != item.mois) {
          for (let i = monthCurrent; i < item.mois; i++) {
            monthCurrent++
            toPush.data.push(0)
          }
        }

        if (monthCurrent == item.mois) {
          toPush.data.push(Math.round(item.somme))
          monthCurrent++
        }
        if (index == array.length - 1)
          this.chartdataMontants.datasets.push(toPush)
      })
      // console.log(this.chartdataMontants.datasets)
      return true
    },
    getChartDataForMontantsEnSomme: function () {
      this.chartdataMontantsSomme.datasets = []
      //     label: 'Montants par année',
      //     backgroundColor: '#FFF000',
      //     data: []
      // })
      let monthCurrent = 1;
      let yearPrec = 0;
      let sommeByMonthYear = 0;
      let toPush = {}
      this.stats.montantsByYearByMonth.forEach((item, index, array) => {
        if (yearPrec != item.annee) {
          if (yearPrec != 0)
            this.chartdataMontantsSomme.datasets.push(toPush)
          yearPrec = item.annee
          monthCurrent = 1;
          sommeByMonthYear = 0;
          let color = this.getColor()
          toPush = {
            label: item.annee,
            borderColor: this.hexToRGB(color, 1),
            backgroundColor: this.hexToRGB(color, 0.1),
            data: []
          }
        }
        if (monthCurrent != item.mois) {
          for (let i = monthCurrent; i < item.mois; i++) {
            monthCurrent++
            toPush.data.push(sommeByMonthYear)
          }
        }

        if (monthCurrent == item.mois) {
          sommeByMonthYear = sommeByMonthYear + Math.round(item.somme)
          toPush.data.push(sommeByMonthYear)
          monthCurrent++
        }
        if (index == array.length - 1)
          this.chartdataMontantsSomme.datasets.push(toPush)
      })
      // console.log(this.chartdataMontantsSomme.datasets)
      return true
    },
    hexToRGB: function (hex, alpha) {
      let r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

      if (alpha) {
        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
      } else {
        return "rgb(" + r + ", " + g + ", " + b + ")";
      }
    },
    getColor: function () {
      let color = this.colors[0];
      this.colors.shift();
      return color;
    },
    getDifference: function () {
      return 0
    },
    getDate: function (today = false) {
      return today ? moment().format('DD/MM/YYYY') : moment().year()
    }
  },
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getMajNixinut: 'getMajNixinut',
    }),

  },
  components: {
    BarChartjsDashboard: BarChartjsDashboard,
    LineChartjsDashboard: LineChartjsDashboard
  },
  watch: {
    getMajNixinut: function () {
      this.showModal()
    }
  },
  mounted() {
    this.getStatsClub();
    // this.showModal()
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue